import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { ApiRequestService, ListViewComponent, ToastmessageService, TranslationPipe, TranslationService } from '@prekog/common-ui';
import { OnSalePeriod } from './addproductsonsale/onsaleperiod';
import { GetOnSalePeriodResponse } from './getonsaleperiodresponse';

@Component({
    selector: 'app-getexistingonsaleperiods',
    templateUrl: './onsaleperiods.component.html',
    styleUrls: ['./onsaleperiods.component.scss'],
    standalone: true,
    imports: [MatIconModule, RouterModule, CommonModule, FormsModule, ListViewComponent, TranslationPipe]
})
export class OnsaleperiodsComponent implements OnInit {
    filteredOnSalePeriods: OnSalePeriod[] = [];

    getOnSalePeriodsUrl = '/admin/get-on-sale-periods';

    onSalePeriod?: OnSalePeriod[] = [];

    searchText = '';

    storeBaseUrl = '';

    constructor(
        private _router: Router,
        private _fb: FormBuilder,
        private _toastMessageService: ToastmessageService,
        @Inject('STORE_BACKEND_URL') private _storeBaseUrl: string,
        private _apiRequestService: ApiRequestService,
        private _translateService: TranslationService
    ) {
        this.storeBaseUrl = _storeBaseUrl;
    }

    ngOnInit(): void {
        if (sessionStorage.getItem('token')) {
            this._apiRequestService
                .sendRequest<{}, GetOnSalePeriodResponse>(this.storeBaseUrl, {}, true, this.getOnSalePeriodsUrl)
                .subscribe((response) => {
                    this.onSalePeriod = response.onSalePeriodList as OnSalePeriod[];
                    this.filteredOnSalePeriods = this.onSalePeriod!;
                });
        } else {
            this._router.navigateByUrl('/');
        }
    }
}
